import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateWarehouse($companyId: ID!, $attributes: WarehouseAttributes!) {
    createWarehouse(companyId: $companyId, attributes: $attributes) {
      warehouse {
        id
        ...CreatedWarehouse
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedWarehouse on Warehouse {
    id
    name
    address1
    address2
    address3
    city
    county
    postcode
    address
  }
`
